/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit IconAndTitle/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import AssignedToMe from './AssignedToMe/index'
import React from 'react'
import TaskBoardIcon from 'DesignSystem/TaskBoardIcon/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function IconAndTitle({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Content/Boards/Content/BoardItem/IconAndTitle"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let flow = fromFlow.useFlow()
let boardIdValueData = fromData.useDataValue({ viewPath,
context: 'board',
path: 'id',
})
let tabSelectedBoardIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.board_id',
})
let aggregateData = fromAggregate.equals(boardIdValueData, tabSelectedBoardIdValueData)
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let boardMetadataBoardIconIdValueData = fromData.useDataValue({ viewPath,
context: 'board',
path: 'metadata.board_icon_id',
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let boardNameValueData = fromData.useDataValue({ viewPath,
context: 'board',
path: 'name',
})
let boardNewTasksCountValueData = fromData.useDataValue({ viewPath,
context: 'board',
path: 'new_tasks_count',
})
let dtFontsizesMm = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'fontSizes.mm'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<button
  data-testid="IconAndTitle.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--btrr-2-Yt0bK': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--btlr-3-Yt0bK': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bbrr-4-Yt0bK': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bblr-5-Yt0bK': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--mt-6-Yt0bK': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-1-Yt0bK': flow.has(fromFlow.normalizePath(viewPath, '../../../../../Content/Home')) ? dtColorsWhite : aggregateData ? dtColorsNeutral200 : dtColorsWhite}}
 className={`views-block ${styles.Horizontal}`}
>
<TaskBoardIcon
  viewPath={`${viewPath}/TaskBoardIcon`}
 width={48}
 height={48}
 iconHeight={18}
 iconWidth={18}
 borderTopRightRadius={0}
 borderBottomRightRadius={0}
 borderTopLeftRadius={dtSpaceMs}
 borderBottomLeftRadius={dtSpaceMs}
 data="board.metadata.board_icon_id"
 iconId={boardMetadataBoardIconIdValueData}
/>
<div
  data-testid="IconAndTitle.Vertical"
  data-view-path={viewPath}
 style={{'--ml-7-Yt0bK': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
/>
</div>
<div
  data-testid="IconAndTitle.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pr-8-Yt0bK': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="IconAndTitle.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 width={144}
 display="inline-block"
 textOverflow="ellipsis"
 overflowX="hidden"
 whiteSpace="nowrap"
 weight="medium"
 data="board.name"
 text={boardNameValueData}
/>
<AssignedToMe
  viewPath={`${viewPath}/AssignedToMe`}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={dtFontsizesMm}
 weight="medium"
 color={dtColorsNeutral500}
 data="board.new_tasks_count"
 text={boardNewTasksCountValueData}
/>
</div>
</button>
{children}
</React.Fragment>)
}